export enum ReasonInserieActivaton {
  DATA_UPDATE = 'modules.data-management.serien-daten.modal.bdp-activation-reason-dataupdate',
  FAULTY_BDP = 'modules.data-management.serien-daten.modal.bdp-activation-reason-wrongsdp',
  OTHER = 'modules.data-management.serien-daten.modal.bdp-activation-reason-other',
}
